module.exports = __webpack_public_path__ + "img/XK.b66aec01.png";